<template>
  <div>
    <el-row id="card-zoom" type="flex" justify="center">
      <el-col class="flex-center" :span="2">
        <el-button class="icon-button" @click="zoomOut">
          <i class="fal fa-search-minus color-white"></i>
        </el-button>
      </el-col>
      <el-col class="flex-center" :span="2">
        <el-button :disabled="true">
          {{ this.scaleZoomPorcentagem }}%
        </el-button>
      </el-col>
      <el-col class="flex-center" :span="2">
        <el-button class="icon-button" @click="zoomIn">
          <i class="fal fa-search-plus color-white"></i>
        </el-button>
      </el-col>
      <el-col class="flex-center" :span="2">
        <el-button class="icon-button" @click="rotateLeft">
          <i class="fal fa-undo-alt color-white"></i>
        </el-button>
      </el-col>
      <el-col class="flex-center" :span="2">
        <el-button class="icon-button" @click="rotateRight">
          <i class="fal fa-redo-alt color-white"></i>
        </el-button>
      </el-col>
    </el-row>
    <div>
      <app-vue-perfect-scrollbar
        :settings='settings'
        class="scroll-area"
      >
        <div id="image-container">
          <img id="document-img-view" :src="imgSrc" />
        </div>
      </app-vue-perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import AppVuePerfectScrollbar from 'vue-perfect-scrollbar'
import { bytesToBase64 } from '@/libs/utils/functions/base64'

export default {
  components: {
    AppVuePerfectScrollbar
  },

  props: {
    bytes: {
      required: true,
      type: [ArrayBuffer, String]
    },
    minZoom: {
      type: Number,
      default: 30
    },
    scaleZoomResize: {
      type: Number,
      default: 5
    }
  },

  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      scaleZoomPorcentagem: 100,
      widthImage: null,
      rotationAngle: 0
    }
  },

  computed: {
    imgSrc () {
      return 'data:image/png;base64,' + (this.bytes instanceof ArrayBuffer ? bytesToBase64(this.bytes) : this.bytes)
    },
    imageElement () {
      return document.getElementById('document-img-view')
    }
  },

  methods: {
    async zoomIn () {
      this.scaleZoomPorcentagem = this.scaleZoomPorcentagem + this.scaleZoomResize

      this.resizeImageWithZoom()
    },
    async zoomOut () {
      if (this.scaleZoomPorcentagem > this.minZoom) {
        this.scaleZoomPorcentagem = this.scaleZoomPorcentagem - this.scaleZoomResize

        this.resizeImageWithZoom()
      }
    },
    rotateLeft () {
      this.rotationAngle -= 90
      if (this.rotationAngle < 0) {
        this.rotationAngle += 360
      }
      this.applyImageRotate()
    },
    rotateRight () {
      this.rotationAngle += 90
      if (this.rotationAngle >= 360) {
        this.rotationAngle -= 360
      }
      this.applyImageRotate()
    },
    resizeImageWithZoom () {
      if (this.widthImage === null) {
        this.widthImage = this.imageElement.clientWidth
      }
      this.imageElement.style.width = (this.scaleZoomPorcentagem * this.widthImage) / 100 + 'px'
    },
    applyImageRotate () {
      this.imageElement.style.transform = `rotate(${this.rotationAngle}deg)`
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizarDocumentos/ImageViewer/ImageViewer.vue